module.exports = __webpack_public_path__ + "static/wtl-group-logo-bb1251dcd523fd209349940e6e3aa195.png";